module.exports = __webpack_public_path__ + "static/assets/70c5adeff38eae396dc54ef2e9910e45.svg";